import Http from '../../../http';

export const fetchEcommerceSyncSettings = (brandId, vendor) =>
  Http.get(`/ecommerce-sync/settings/${brandId}/${vendor}`);

// When you send request to POST /v1/ecommerce-sync/save-match/:accountId
// to store a match, you need to pass id from response above in ids[] param
// actually list of ids separated by comma
export const manageProductsConnection = (brandId, vendor, ids, status) =>
  Http.post(`/ecommerce-sync/save-match/${brandId}`, {
    ids,
    vendor,
    status,
  });

export const getMatches = (brandId, locationType, locationId, status, type, limit, page) =>
  Http.get(`/ecommerce-sync/matches/${brandId}/${locationType}/${locationId}`, {
    status,
    type,
    limit,
    page,
  });

export const getMatch = (brandId, itemId, sku) =>
  Http.get(`/ecommerce-sync/match/${brandId}/${itemId}`, {
    sku,
  });

export const getNewProductMatch = (brandId, sku) =>
  Http.get(`/ecommerce-sync/match/${brandId}`, {
    sku,
  });

export const disconnectShopify = (brandId, vendor) =>
  Http.delete(`/ecommerce-sync/disconnect/${brandId}/${vendor}`);

export const fetchShopifyFulfillmentLocations = (brandId, vendor) =>
  Http.get(`/ecommerce-sync/remote-locations/${brandId}/${vendor}`);

export const saveShopifySettings = (brandId, data) =>
  Http.post(`/ecommerce-sync/settings/${brandId}`, data);

export const sendShopifyTokenToBackend = (brandId, vendor, { code, hmac, host, shop, state, timestamp }) =>
  Http.get(`/ecommerce-sync/authorize/${brandId}/${vendor}`, {
    code,
    hmac,
    host,
    shop,
    state,
    timestamp,
  });
